import React from 'react';

const Stylists = () => {
  const stylists = [
    {
      name: "Lufuno",
      specialty: "Owner",
      image: "/stylists/Lufuno.jpg",
      alt: "Lufuno"
    },
    {
      name: "Minnie",
      specialty: "Stylist",
      image: "/stylists/Minnie.jpg",
      alt: "Minnie"
    },
    {
      name: "Thamathama",
      specialty: "Stylist",
      image: "/stylists/Thamathama.jpg",
      alt: "Thamathama"
    },
    {
      name: "Dikatso (Dee)",
      specialty: "Somatologist",
      image: "/stylists/s1.jpeg",
      alt: "Dikatso (Dee)"
    },
    {
      name: "Lele",
      specialty: "Lash Tech",
      image: "/stylists/Lele.jpg",
      alt: "Lele"
    }
  ];

  return (
    <section id="stylists" style={{ background: '#F9F8F5' }} className="py-5">
      <div className="container">
        <h2 className="text-center fw-bold mb-2"
          style={{
            color: "#2c2c2c",
            fontFamily: "'Playfair Display',serif",
            letterSpacing: ".025em",
            fontSize: "1.28rem"
          }}>
          Our Stylists
        </h2>
        <p className="text-center text-muted mb-3"
          style={{
            fontWeight: 400,
            fontSize: ".97rem",
            maxWidth: 450,
            margin: "0 auto"
          }}>
          Meet the talented team behind Zoteya Beauty.
        </p>
        <div className="row g-2 justify-content-center"
          style={{ rowGap: '0.7rem', columnGap: '0.95rem' }}>
          {stylists.map((stylist, index) => (
            <div
              key={index}
              className="col-6 col-md-4 col-lg-3 d-flex flex-column align-items-center"
              style={{
                minWidth: 145,
                maxWidth: 190,
                margin: "0 auto",
                padding: 0
              }}
            >
              <div
                className="w-100"
                style={{
                  background: "#fff",
                  borderRadius: 10,
                  boxShadow: "0 2px 7px #cab38a19",
                  padding: 0,
                  overflow: "hidden",
                  transition: "box-shadow .16s,transform .16s",
                  height: 240, // Card is now proportional to image!
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  position: "relative"
                }}
              >
                {/* Image fills entire card */}
                <img
                  src={stylist.image}
                  alt={stylist.alt}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // Ensures full coverage
                    display: "block",
                    background: "#ede5d1"
                  }}
                  onError={e => {
                    if (!e.target.dataset.fallback) {
                      e.target.dataset.fallback = "true";
                      e.target.src = "/placeholder-image.jpg";
                    }
                  }}
                />

                {/* Name and badge -- absolute over bottom, consistent everywhere */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    background: "rgba(250,245,226,0.82)",
                    padding: "12px 0 4px 0",
                    borderBottomLeftRadius: 10,
                    borderBottomRightRadius: 10,
                    textAlign: "center"
                  }}
                >
                  <div style={{
                    fontSize: ".99em",
                    fontWeight: 700,
                    color: "#62470f",
                    fontFamily: "'Playfair Display',serif",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}>
                    {stylist.name}
                  </div>
                  <div style={{
                    fontSize: ".92em",
                    fontWeight: 600,
                    letterSpacing: ".012em",
                    color: "#2c2c2c"
                  }}>
                    {stylist.specialty}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stylists;

